import useSWR from "swr";
import axios, { AxiosError } from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { DataContext } from "../../../context/DataContext";
import { HYPERLIQUID_API_URL } from "../../../utils/env";
import { HyperliquidEndpointEnum } from "../../../enums/endpoints";
import {
  IHyperliquidPosition,
  IHyperliquidPositionsResponse,
} from "../../../interfaces/hyperliquid";
import { hyperliquidAddresses } from "../../../constants/admin";

interface IApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

const fetchHyperliquidPositions = async (
  tokenId: string,
  account: string
): Promise<IHyperliquidPosition[]> => {
  try {
    const response = await axios.get<IApiResponse<IHyperliquidPositionsResponse>>(
      HYPERLIQUID_API_URL(HyperliquidEndpointEnum.ACCOUNT_POSITIONS),
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${tokenId}`,
          "Access-Control-Allow-Origin": "*",
        },
        params: {
          account,
        },
      }
    );

    if (response.data?.success && response.data?.data?.positions) {
      return response.data.data.positions;
    }
  } catch (error) {
    console.error(error);
  }

  return [];
};

export const useHyperliquidPositions = (overrideAccount?: string) => {
  const { tokenId } = useContext(AuthContext);
  const { address } = useContext(DataContext);
  const account = overrideAccount || address;

  const swr = useSWR<IHyperliquidPosition[], AxiosError>(
    tokenId && account && hyperliquidAddresses.includes(account) ?
      [HYPERLIQUID_API_URL(HyperliquidEndpointEnum.ACCOUNT_POSITIONS), tokenId, account] :
      undefined,
    async () => fetchHyperliquidPositions(tokenId!, account!),
    {
      refreshInterval: 10000,
    }
  );

  return {
    ...swr,
  };
};
